import { createSlice } from '@reduxjs/toolkit';

import { apiReducerBuilder } from 'utils';

import { Action } from 'models/api';

import { checkResetPasswordToken, recoveryPassword, resetPassword } from './actions';
import { logout } from '../authorization/actions';

interface ForgotPassword {
	status: string;
	step: number;
}

const initialState = { step: 1 } as ForgotPassword;

const forgotPasswordSlice = createSlice({
	name: 'forgotPassword',
	initialState,
	reducers: {
		setForgotPasswordStep(state, action) {
			state.step = action.payload;
		},
	},
	extraReducers: (builder) => {
		apiReducerBuilder(builder, recoveryPassword, (state, action: Action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
			state.step = 2;
		});
		apiReducerBuilder(builder, resetPassword, (state, action: Action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
			state.step = 4;
		});

		apiReducerBuilder(builder, checkResetPasswordToken, (state, action: Action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
		});

		builder.addCase(logout, (state) => {
			return initialState;
		});
	},
});

export const { setForgotPasswordStep } = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
